<template>
  <div class="alipay-container">
    <!-- 面包屑导航 -->
    <div class="breadcrumb-wrapper">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/Welcome' }">
          <i class="el-icon-s-home"></i> 首页
        </el-breadcrumb-item>
        <el-breadcrumb-item>
          <i class="el-icon-folder-opened"></i> 展会分类管理
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <!-- 卡片内容 -->
    <el-card class="alipay-card" shadow="never">
      <!-- 搜索栏 -->
      <div class="search-bar">
        <el-form :model="searchForm" size="small" label-width="70px" label-position="right">
          <el-row :gutter="16">
            <el-col :span="6">
              <el-form-item label="分类名称">
                <el-input
                  v-model="searchForm.name"
                  placeholder="请输入分类名称"
                  prefix-icon="el-icon-search"
                  clearable
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item size="small" label="状态">
                <el-select
                  v-model="searchForm.status"
                  placeholder="请选择状态"
                  clearable
                >
                  <el-option label="启用" :value="1"></el-option>
                  <el-option label="禁用" :value="0"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12" class="search-actions">
              <el-button size="small" type="primary" @click="searchSubmit" icon="el-icon-search">搜索</el-button>
              <el-button size="small" @click="resetSearch" icon="el-icon-refresh-right">重置</el-button>
              <el-button size="small" type="success" @click="addData" icon="el-icon-plus">新增分类</el-button>
            </el-col>
          </el-row>
        </el-form>
      </div>

      <!-- 统计卡片 -->
      <div class="stat-cards">
        <div class="stat-card" @click="filterStatus('all')">
          <div class="stat-icon total"><i class="el-icon-folder-opened"></i></div>
          <div class="stat-info">
            <div class="stat-value">{{ totalCount }}</div>
            <div class="stat-label">全部分类</div>
          </div>
        </div>
        <div class="stat-card" @click="filterStatus(1)">
          <div class="stat-icon approved"><i class="el-icon-check"></i></div>
          <div class="stat-info">
            <div class="stat-value">{{ enableCount }}</div>
            <div class="stat-label">启用分类</div>
          </div>
        </div>
        <div class="stat-card" @click="filterStatus(0)">
          <div class="stat-icon rejected"><i class="el-icon-close"></i></div>
          <div class="stat-info">
            <div class="stat-value">{{ disableCount }}</div>
            <div class="stat-label">禁用分类</div>
          </div>
        </div>
      </div>

      <!-- 表格 -->
      <div class="table-wrapper">
        <el-table
          ref="multipleTable"
          :data="tableLoadData"
          stripe
          border
          size="medium"
          row-key="id"
          :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
          :header-cell-style="headerCellStyle"
          :row-style="rowStyle"
          v-loading="loading"
          element-loading-text="加载中..."
        >
          <el-table-column :index="indexMethod" type="index" label="序号" width="60" align="center"></el-table-column>

          <el-table-column label="分类信息" min-width="200">
            <template slot-scope="scope">
              <div class="shop-info">
                <div class="shop-name"><i class="el-icon-folder"></i><span>{{ scope.row.name }}</span></div>
                <div class="shop-sn"><span class="label">排序：</span><span class="value">{{ scope.row.sort }}</span></div>
              </div>
            </template>
          </el-table-column>

          <el-table-column label="上级分类" width="120" align="center">
            <template slot-scope="scope">
              <el-tag size="small" type="primary" effect="plain">
                {{ scope.row.parent_id === 0 ? '顶级分类' : '子分类' }}
              </el-tag>
            </template>
          </el-table-column>

          <el-table-column label="状态" width="100" align="center">
            <template slot-scope="scope">
              <el-tag :type="scope.row.status == 1 ? 'success' : 'danger'" size="small" effect="plain">
                {{ scope.row.status == 1 ? '启用' : '禁用' }}
              </el-tag>
            </template>
          </el-table-column>

          <el-table-column label="备注" min-width="150" align="center">
            <template slot-scope="scope">
              <span style="color:#666">{{ scope.row.remark || '-' }}</span>
            </template>
          </el-table-column>

          <el-table-column label="操作" width="160" align="center" fixed="right">
            <template slot-scope="scope">
              <el-dropdown trigger="click" @command="handleCommand($event, scope.row)">
                <el-button type="primary" size="small" plain>
                  更多操作 <i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="edit"><i class="el-icon-edit"></i> 修改</el-dropdown-item>
                  <el-dropdown-item command="del" type="danger"><i class="el-icon-delete"></i> 删除</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!-- 空状态 -->
      <div v-if="tableLoadData.length === 0 && !loading" class="empty-state">
        <i class="el-icon-folder-opened"></i><p>暂无展会分类数据</p>
        <el-button type="primary" size="small" @click="addData">立即添加</el-button>
      </div>
    </el-card>

    <!-- 新增/编辑弹框 -->
    <el-dialog :title="dialogTitle" :visible.sync="dialogFormVisible" width="450px" :close-on-click-modal="false" class="alipay-dialog" @closed="handleDialogClosed">
      <div class="dialog-content">
        <el-form :model="form" :rules="rules" ref="form" label-width="100px" label-position="right">
          <el-form-item label="上级分类" prop="parent_id">
            <el-select v-model="form.parent_id" placeholder="请选择上级分类" class="full-width">
              <el-option label="顶级分类" :value="0"></el-option>
              <el-option
                v-for="item in categoryList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="分类名称" prop="name">
            <el-input v-model="form.name" placeholder="请输入分类名称"></el-input>
          </el-form-item>
          <el-form-item label="排序" prop="sort">
            <el-input-number v-model.number="form.sort" :min="0" style="width:100%"></el-input-number>
          </el-form-item>
          <el-form-item label="状态" prop="status">
            <el-select v-model="form.status" placeholder="请选择状态" class="full-width">
              <el-option label="启用" :value="1"><span style="color: #00b578;">● 启用</span></el-option>
              <el-option label="禁用" :value="0"><span style="color: #ff4d4f;">● 禁用</span></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="备注">
            <el-input v-model="form.remark" type="textarea" :rows="2"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="medium" @click="cancelForm">取 消</el-button>
        <el-button size="medium" type="primary" @click="submitForm">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "ExpoCategoryList",
  data() {
    return {
      loading: false,
      totalCount: 0,
      enableCount: 0,
      disableCount: 0,
      searchForm: { name: "", status: "" },
      tableLoadData: [],
      categoryList: [],
      dialogFormVisible: false,
      dialogTitle: "",
      form: { id: "", parent_id: 0, name: "", sort: 0, status: 1, remark: "" },
      rules: {
        name: [{ required: true, message: "请输入分类名称", trigger: "blur" }]
      }
    };
  },
  created() {
    this.DataList();
  },
  methods: {
    headerCellStyle() {
      return { background: "#f5f7fa", color: "#1f2d3d", fontWeight: "500" };
    },
    rowStyle() {
      return { cursor: "pointer" };
    },
    indexMethod(index) {
      return index + 1;
    },

    // 获取分类列表
    async DataList() {
      this.loading = true;
      const param = {
        company_id: sessionStorage.getItem("company_id"),
        access_token: sessionStorage.getItem("token"),
        name: this.searchForm.name,
        status: this.searchForm.status
      };
      const res = await this.$axios.findExpoCategoryTree(param);
      this.loading = false;
      if (res.code === 200) {
        this.tableLoadData = res.data || [];
        this.categoryList = res.data || [];
        this.calculateStats();
      }
    },

    // 统计
    calculateStats() {
      let total = this.tableLoadData.length;
      let enable = this.tableLoadData.filter((i) => i.status == 1).length;
      let disable = total - enable;
      this.totalCount = total;
      this.enableCount = enable;
      this.disableCount = disable;
    },

    // 搜索
    searchSubmit() {
      this.DataList();
    },
    resetSearch() {
      this.searchForm = { name: "", status: "" };
      this.DataList();
    },

    // 筛选状态
    filterStatus(val) {
      this.searchForm.status = val === "all" ? "" : val;
      this.DataList();
    },

    // 新增
    addData() {
      this.dialogTitle = "新增展会分类";
      this.form = { id: "", parent_id: 0, name: "", sort: 0, status: 1, remark: "" };
      this.dialogFormVisible = true;
    },

    // 编辑
    editData(row) {
      this.dialogTitle = "编辑展会分类";
      this.form = { ...row };
      this.dialogFormVisible = true;
    },

    // 删除
    async delData(row) {
      await this.$confirm("确定删除该分类？", "提示");
      const res = await this.$axios.expoCategoryDel({ id: row.id });
      console.log(res)
      this.$message.success("删除成功");
      this.DataList();
    },

    // 提交
    async submitForm() {
      await this.$refs.form.validate();
      const param = {
        ...this.form,
             access_token: sessionStorage.getItem("token"),
        company_id: sessionStorage.getItem("company_id")
      };
      if (this.form.id) {
        await this.$axios.expoCategoryEdit(param);
      } else {
        await this.$axios.expoCategorySave(param);
      }
      this.$message.success("操作成功");
      this.dialogFormVisible = false;
      this.DataList();
    },

    handleCommand(command, row) {
      switch (command) {
        case "edit":
          this.editData(row);
          break;
        case "del":
          this.delData(row);
          break;
      }
    },

    handleDialogClosed() {
      this.$refs.form?.resetFields();
    },
    cancelForm() {
      this.dialogFormVisible = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.alipay-container {
  padding: 16px 20px;
  background: #f5f7fa;
  min-height: calc(100vh - 60px);
}

.breadcrumb-wrapper {
  margin-bottom: 16px;
  .el-breadcrumb {
    font-size: 14px;
    i {
      margin-right: 4px;
    }
  }
}

.alipay-card {
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);
  .el-card__body {
    padding: 20px 24px;
  }
}

.search-bar {
  background: #f8f9fc;
  padding: 20px;
  border-radius: 12px;
  margin-bottom: 20px;
  .el-form-item {
    margin-bottom: 16px;
  }
  .search-actions {
    display: flex;
    gap: 10px;
    justify-content: flex-end;
    .el-button {
      border-radius: 20px;
    }
  }
}

.stat-cards {
  display: flex;
  gap: 20px;
  margin-bottom: 24px;
  flex-wrap: wrap;
  .stat-card {
    flex: 1;
    min-width: 160px;
    background: #fff;
    border-radius: 16px;
    padding: 20px;
    display: flex;
    align-items: center;
    gap: 16px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
    cursor: pointer;
    &:hover {
      transform: translateY(-2px);
    }
    .stat-icon {
      width: 48px;
      height: 48px;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 24px;
      color: #fff;
    }
    .stat-info {
      .stat-value {
        font-size: 28px;
        font-weight: 700;
      }
      .stat-label {
        font-size: 13px;
        color: #8c8f98;
      }
    }
    .total {
      background: linear-gradient(135deg, #1677ff, #4096ff);
    }
    .approved {
      background: linear-gradient(135deg, #00b578, #1acd8c);
    }
    .rejected {
      background: linear-gradient(135deg, #ff4d4f, #ff7875);
    }
  }
}

.table-wrapper {
  min-height: 350px;
}

.shop-info {
  .shop-name {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 4px;
    i {
      color: #1677ff;
    }
  }
  .shop-sn {
    .label {
      font-size: 12px;
      color: #8c8f98;
    }
    .value {
      font-size: 12px;
      color: #1677ff;
    }
  }
}

.empty-state {
  text-align: center;
  padding: 60px 0;
  i {
    font-size: 64px;
    color: #c0c4cc;
  }
}

.alipay-dialog {
  ::v-deep .el-dialog {
    border-radius: 20px;
  }
  ::v-deep .el-dialog__header {
    background: linear-gradient(135deg, #1677ff, #4096ff);
    color: #fff;
  }
  ::v-deep .el-dialog__title {
    color: #fff;
  }
}

.dialog-footer {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  .el-button {
    border-radius: 24px;
  }
}
</style>